module.exports = __webpack_public_path__ + "img/BAWS_Sword2_3_3.1d605c15.png";